import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class RiskService {
    constructor(private datatask: DataTaskService) {}
    public async getElement(params: { riskelement_keyno: string }): Promise<RiskElementGet> { return (await this.datatask.Post(269, params))[0]; }
    public listProbabilities(): Promise<RiskProbability[]> { return this.datatask.Post(270, {}); }
    public listConsequences(): Promise<RiskConsequence[]> { return this.datatask.Post(271, {}); }
    public listRisks(): Promise<RiskScore[]> { return this.datatask.Post(272, {}); }
    public listLevels(): Promise<RiskLevel[]> { return this.datatask.Post(277, {}); }
    public listElements(params: RiskListParams): Promise<RiskItem[]> { return this.datatask.Post(268, params); }
    public listCounts(params: RiskContext): Promise<RiskCount[]> { return this.datatask.Post(275, params); }
    public listLogs(params: { riskelement_keyno: string }): Promise<RiskItem[]> { return this.datatask.Post(307, params); }
    public async saveElement(page: RiskElementGet): Promise<void> { await this.datatask.Post(273, page); }
    public async confirmElement(params: { riskelement_keyno: string }): Promise<void> { await this.datatask.Post(306, params); }
    public async deleteElement(params: { riskelement_keyno: string }): Promise<void> { await this.datatask.Post(274, params); }
}
export interface RiskContext { argtype: string; argvalue: string; }
export interface RiskListParams extends RiskContext { probability_no: string | number; consequence_no: string | number; }
export interface RiskElementGet extends Record<string, unknown> {
    riskelement_keyno: string;
    jobelement: string;
    risk_description: string;
    probability_no: string;
    consequence_no: string;
    risk_no: string;
    probability_description: string;
    consequence_description: string;
    actions_probability: string;
    actions_consequence: string;
    reg_by_portal_user_name: string;
    custact_no: string | number;
}
export interface RiskProbability { probability_no: string; probability_name: string; }
export interface RiskConsequence { consequence_no: string; consequence_name: string; }
export interface RiskScore { risk_no: string; risk_name: string; }
export interface RiskLevel { risklevel_no: string | number; risklevel: string; risklevel_action: string; }
export interface RiskCount { probability_no: string | number; consequence_no: string | number; nbr: string | number; }
export interface RiskItem extends Item { item_id: string; item_name: string; }
